import type { ReactNode } from "react";
import { Chip, Grid, Typography } from "@mui/material";

export function AffectationAntenneCommunesLegende(): ReactNode {
  return (
    <Typography variant="caption">
      Légende
      <Grid container spacing={1}>
        <Chip label="Affectation existante" />
        <Chip label="Nouvelle affectation" color="info" />
        <Chip label="Affectation existante qui sera supprimée" color="error" />
      </Grid>
    </Typography>
  );
}
